import * as types from './mutation-types'

const state = {
  notification: null
}

const getters = {
  getNotification (state) {
    return state.notification
  }
}

const actions = {
  notify ({ commit }, data) {
    commit(types.SET_NOTIFICATION, data)
  },
  cleanNotification ({ commit }) {
    commit(types.CLEAN_NOTIFICATION)
  }
}

const mutations = {
  [types.CLEAN_NOTIFICATION] (state) {
    state.notification = null
  },
  [types.SET_NOTIFICATION] (state, { type, message }) {
    state.notification = {
      type,
      message
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/notification.js